import { NgModule } from '@angular/core';
import { ReplacePipe } from './replace';
import { CapitalizeFirstPipe } from './capitalizeFirst';
import { AsyncFilterPipe } from './async-filter';
import { LocationIsAssignedPipe } from './location-is-assigned';
import { HasPermissionPipe } from './has-permission-pipe';

@NgModule({
  imports: [],
  declarations: [
    ReplacePipe,
    CapitalizeFirstPipe,
    AsyncFilterPipe,
    LocationIsAssignedPipe,
    HasPermissionPipe,
  ],
  exports: [
    ReplacePipe,
    CapitalizeFirstPipe,
    AsyncFilterPipe,
    LocationIsAssignedPipe,
    HasPermissionPipe,
  ]
})

export class PipesModule {
}
